import {HibuEqualsFilter, HibuFacetFilter, HibuFacetGroup, HibuRangeFilter} from './facet.types';

export const facetUtils = {
    // Check if at least one filter exists
    hasAnySelectedFilter: (selectedFilters: HibuFacetFilter): boolean =>
        Object.values(selectedFilters).some((arr) => arr.length > 0),

    // Check if two equal filters are the same
    isSameEqualsFilter: (a: HibuEqualsFilter, b: HibuEqualsFilter) =>
        a.type === b.type && a.value === b.value,

    // Check if two range filters are the same
    isSameRangeFilter: (a: HibuRangeFilter, b: HibuRangeFilter) =>
        a.type === b.type && a.gte === b.gte && a.lt === b.lt,
    isInvertedFilter(f: HibuEqualsFilter) {
        return f.invert;
    },

    // Check if there are any values or an errorCode present
    shouldDisplayFacetGroup(group: HibuFacetGroup) {
        return group.values.length > 0 || group.errorCode;
    }
};


export const getIndentedDirPath = (path: string): string => {
    // Early return for root or non-path strings
    if (!path.includes('/') || path === '/') {
        return path;
    }

    // If the path starts with '/' we have to remove it --> /root/level1/subFolderLevel2 -> root/level1/subFolderLevel2
    let cleanedPath = path;
    if (path.startsWith('/')) {
        cleanedPath = path.slice(1);
    }

    const splitPath: string[] = cleanedPath.split('/'); // [root, level1, subFolderLevel2]
    const countDir = splitPath.length - 1;
    const lastDirOnPath = splitPath[countDir];

    const separator = document.body?.clientWidth <= 1024 ? ' ' : '   ';
    const subfolderCharacter = `<div class="subfolder-character">${separator.repeat(Math.max(countDir - 1, 0))}└ </div>`;
    return `<div class="subfolder-facet-value">${subfolderCharacter}<div class="subfolder-facet-text">${lastDirOnPath}</div></div>`;
};
